/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_Banking_InfoInputs */

const en_clients_section_banking_info = /** @type {(inputs: Clients_Section_Banking_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banking Info`)
};

const pt_br2_clients_section_banking_info = /** @type {(inputs: Clients_Section_Banking_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados Bancários`)
};

/**
* | output |
* | --- |
* | "Banking Info" |
*
* @param {Clients_Section_Banking_InfoInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_banking_info = /** @type {((inputs?: Clients_Section_Banking_InfoInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_Banking_InfoInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_banking_info(inputs)
	return pt_br2_clients_section_banking_info(inputs)
});